import {
    // primaryColor,
    dangerColor,
    successColor,
    defaultFont
} from "../../assets/jss/dibots-global-style";

const customInputStyle = {
    disabled: {
        color: "grey",
        "&:before": {
            // borderColor: "transparent !important"
            borderBottomStyle: "dashed !important"
        }
    },
    underline: {
        "&:hover:not($disabled):before,&:before": {
            borderColor: "#003663",
            borderWidth: "1px !important"
        },
        "&:after": {
            // borderColor: primaryColor
            borderColor: "#003663"
        }
    },
    underlineError: {
        "&:after": {
            borderColor: dangerColor + " !important"
        }
    },
    underlineSuccess: {
        "&:after": {
            borderColor: successColor + " !important"
        }
    },
    whiteUnderline: {
        "&:hover:not($disabled):before,&:before": {
            borderColor: "#FFFFFF"
        },
        "&:after": {
            borderColor: "#FFFFFF"
        }
    },
    labelRoot: {
        ...defaultFont,
        color: "#3C4858 !important",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "1.42857",
        top: "10px",
        "& + $underline": {
            marginTop: "0px"
        }
    },
    labelRootError: {
        color: dangerColor + " !important",
        "& span": {
            color: dangerColor + " !important",
        }
    },
    labelRootSuccess: {
        color: successColor + " !important",
        "& span": {
            color: successColor + " !important",
        }
    },
    whiteLabelRoot: {
        color: "white !important",
        "& span": {
            color: "white !important"
        }
    },
    formControl: {
        margin: "0 0 17px 0",
        paddingTop: "27px",
        position: "relative",
        "& svg,& .fab,& .far,& .fal,& .fas,& .material-icons": {
            color: "#3C4858"
        }
    },
    errorFormControl: {
        "& svg,& .fab,& .far,& .fal,& .fas,& .material-icons": {
            color: dangerColor
        }
    },
    successFormControl: {
        "& svg,& .fab,& .far,& .fal,& .fas,& .material-icons": {
            color: successColor
        }
    },
    whiteFormControl: {
        "& svg,& .fab,& .far,& .fal,& .fas,& .material-icons": {
            color: "white"
        }
    },
    input: {
        color: "#3C4858",
        "&,&::placeholder": {
            fontSize: "14px",
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: "400",
            lineHeight: "1.42857",
            opacity: "1"
        },
        "&::placeholder": {
            color: "#3C4858"
        },
        "&:-internal-autofill-selected": {
            WebkitBoxShadow: "0 0 0px 1000px white inset",
        },
        "&:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0px 1000px white inset",
        }
    },
    errorInput: {
        "&,&::placeholder": {
            color: dangerColor,
            opacity: "1",
        },
        "&:-internal-autofill-selected": {
            WebkitBoxShadow: "0 0 0px 1000px #121212 inset",
            color: dangerColor + " !important",
            WebkitTextFillColor: dangerColor + " !important",
        },
        "&:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0px 1000px #121212 inset",
            color: dangerColor + " !important",
            WebkitTextFillColor: dangerColor + " !important",
        },
    },
    successInput: {
        "&,&::placeholder": {
            color: successColor,
            opacity: "1",
        },
        "&:-internal-autofill-selected": {
            WebkitBoxShadow: "0 0 0px 1000px #121212 inset",
            color: successColor + " !important",
            WebkitTextFillColor: successColor + " !important",
        },
        "&:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0px 1000px #121212 inset",
            color: successColor + " !important",
            WebkitTextFillColor: successColor + " !important",
        },
    },
    whiteInput: {
        "&,&::placeholder": {
            color: "#FFFFFF",
            opacity: "1",
        },
        "&:-internal-autofill-selected": {
            WebkitBoxShadow: "0 0 0px 1000px #121212 inset",
            color: "white !important",
            WebkitTextFillColor: "white !important",
        },
        "&:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0px 1000px #121212 inset",
            color: "white !important",
            WebkitTextFillColor: "white !important",
        },
    },

    formHelperText: {
        fontSize: "10px",
        color: "#003663 !important",
        marginTop: "2px"
    },
    formHelperTextError: {
        color: dangerColor + " !important"
    },
    formHelperTextSuccess: {
        color: successColor + " !important"
    },
    formHelperTextWhite: {
        color: "white !important",
    },
};

export default customInputStyle;
